import type { SVGProps } from "react";

export const Netsuite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    viewBox="0 -40 200.02 152.61"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>NetSuite</title>
    <g>
      <path
        d="m126.14,14.86c-2.64,0-4.86-1.78-5.56-4.2h14.65l2.02-3.14h-16.68c.69-2.44,2.91-4.2,5.56-4.2h10.06l2.01-3.14h-12.3c-4.92,0-8.91,3.99-8.91,8.93s3.99,8.91,8.91,8.91h10.59l2.01-3.14h-12.36Zm-41.96,3.14h10.59l2.01-3.14h-12.35c-3.21,0-5.79-2.59-5.79-5.77s2.58-5.77,5.79-5.77h10.05l2.04-3.16h-12.32c-4.93,0-8.93,3.99-8.93,8.93s4,8.91,8.93,8.91m-65.13-3.14h-9.91c-3.19,0-5.77-2.59-5.77-5.77s2.58-5.77,5.77-5.77h9.9c3.19,0,5.79,2.58,5.79,5.77s-2.58,5.77-5.79,5.77m-10.12,3.14h10.37c4.93,0,8.9-3.99,8.9-8.91S24.23.17,19.29.17h-10.36C3.99.17,0,4.15,0,9.1s3.99,8.91,8.93,8.91Zm36.1-5.77c3.35,0,6.03-2.7,6.03-6.03S48.38.17,45.03.17h-15.01v17.84h3.43V3.33h11.35c1.6,0,2.89,1.29,2.89,2.88s-1.29,2.9-2.89,2.9h-9.66l10.25,8.91h4.97l-6.87-5.77h1.56m56.71,2.61V.17h-3.43v16.14c0,.44.19.87.51,1.18.32.34.78.52,1.24.52h15.63l2.04-3.14h-15.99Zm-41.98-3.14h9.14l-4.83-7.79-8.87,14.08h-4.05L61.98,1.1c.46-.69,1.26-1.1,2.12-1.1s1.62.4,2.09,1.07l10.83,16.94h-4.04l-1.9-3.14h-9.27l-2.02-3.14h0Z"
        fill="currentColor"
      />
      <g>
        <polygon
          fill="currentColor"
          points="25.32 62.57 5.23 32.77 5.14 32.64 0 32.64 0 71.97 5.49 71.97 5.49 42.04 25.58 71.84 25.67 71.97 30.8 71.97 30.8 32.64 25.32 32.64 25.32 62.57"
        />
        <path
          d="m77.06,67.39c-.38.04-.79.05-1.2.05-2.46,0-3.65-1.4-3.65-4.29v-15.06h6.02v-4.53h-6.02v-7.67h-3.4l-1.93,7.63-4.84,1.61v2.95h4.8v15.11c0,3.05.67,5.34,1.99,6.81,1.37,1.48,3.49,2.22,6.29,2.22.57,0,1.12-.02,1.62-.05.54-.04,1.07-.11,1.59-.22l.23-.05v-4.72l-.32.03c-.36.04-.76.09-1.17.16Z"
          fill="currentColor"
        />
        <path
          d="m133.12,61.92c-.73,1.84-1.82,3.34-3.25,4.46-1.4,1.09-2.91,1.65-4.51,1.65-1.89,0-3.34-.61-4.3-1.81-.98-1.22-1.48-3.01-1.48-5.31v-17.35h-5.38v17.51c0,3.68.87,6.54,2.58,8.51,1.76,1.97,4.25,2.98,7.41,2.98,2.06,0,3.99-.48,5.73-1.42,1.57-.83,2.92-2,4.02-3.46l.77,4.3h3.79v-28.4h-5.38v18.36Z"
          fill="currentColor"
        />
        <polygon
          fill="currentColor"
          points="143.7 45.99 146.47 47.75 146.47 71.97 151.85 71.97 151.85 43.57 143.7 43.57 143.7 45.99"
        />
        <rect
          fill="currentColor"
          height="4.9"
          width="6.45"
          x="145.35"
          y="34.35"
        />
        <path
          d="m170.97,67.39c-.38.04-.79.05-1.2.05-2.46,0-3.65-1.4-3.65-4.29v-15.06h6.02v-4.53h-6.02v-7.67h-3.4l-1.93,7.63-4.85,1.61v2.95h4.8v15.11c0,3.05.67,5.34,2,6.81,1.37,1.48,3.49,2.22,6.29,2.22.57,0,1.12-.02,1.62-.05.54-.04,1.07-.11,1.59-.22l.23-.05v-4.72l-.32.03c-.36.04-.76.09-1.17.16Z"
          fill="currentColor"
        />
        <path
          d="m200.02,56.12c0-8.72-4.01-13.14-11.91-13.14-4.08,0-7.27,1.25-9.49,3.72-2.23,2.53-3.27,5.96-3.27,10.8s1.15,8.66,3.43,11.23c2.32,2.54,5.76,3.83,10.23,3.83,1.96,0,3.79-.18,5.45-.54,1.7-.36,3.07-.86,4.09-1.48l.14-.09v-4.67l-.41.19c-1.46.66-2.91,1.16-4.31,1.47-1.4.31-2.9.47-4.47.47-2.79,0-4.91-.69-6.3-2.05-1.35-1.35-2.16-3.5-2.4-6.38h19.22v-3.38Zm-19.22-.99c.17-2.43.86-4.31,2.03-5.59,1.25-1.35,3.03-2.04,5.28-2.04h0c2.39,0,4.1.61,5.11,1.82,1.01,1.18,1.54,3.13,1.58,5.81h-14Z"
          fill="currentColor"
        />
        <path
          d="m48.2,42.98c-4.08,0-7.27,1.25-9.49,3.72-2.23,2.53-3.27,5.96-3.27,10.8s1.15,8.66,3.44,11.23c2.32,2.54,5.76,3.83,10.23,3.83,1.96,0,3.79-.18,5.45-.54,1.7-.36,3.07-.86,4.09-1.48l.14-.09v-4.67l-.41.19c-1.46.66-2.91,1.16-4.31,1.47-1.4.31-2.9.47-4.47.47-2.79,0-4.91-.69-6.3-2.05-1.35-1.35-2.16-3.5-2.4-6.38h19.22v-3.38c0-8.72-4.01-13.14-11.91-13.14Zm-7.31,12.15c.17-2.43.86-4.31,2.03-5.59,1.25-1.35,3.03-2.04,5.28-2.04h0c2.39,0,4.1.61,5.11,1.82,1.01,1.18,1.54,3.13,1.58,5.81h-14Z"
          fill="currentColor"
        />
        <path
          d="m107.75,54.91c-1.51-1.77-4.1-3.37-7.68-4.77l-4.1-1.6c-2.55-1.02-4.35-1.98-5.35-2.88-.98-.87-1.45-1.9-1.45-3.14,0-3.78,2.75-5.62,8.4-5.62,3,0,6.33.78,9.9,2.32l.41.18v-4.99l-.15-.08c-1.33-.72-2.95-1.29-4.82-1.68-1.86-.43-3.69-.65-5.45-.65-4.24,0-7.63.95-10.09,2.83-2.48,1.9-3.74,4.52-3.74,7.8,0,2.3.78,4.34,2.32,6.06,1.55,1.66,4.1,3.19,7.57,4.55l4.11,1.6c2.65,1.02,4.5,2.02,5.5,2.98.97.93,1.46,2.13,1.46,3.57,0,1.98-.8,3.49-2.43,4.61-1.61,1.13-3.91,1.71-6.81,1.71-3.5,0-7.23-.8-11.08-2.38l-.4-.16v4.99l.16.08c.91.44,2.02.84,3.3,1.19,1.29.36,2.68.65,4.14.86,1.49.21,2.94.32,4.3.32,4.49,0,8.03-.99,10.52-2.94,2.55-2,3.84-4.83,3.84-8.39,0-2.48-.8-4.62-2.36-6.37Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default Netsuite;
